module.exports = __webpack_public_path__ + "img/Z61_06.2617d6ae.jpg";